import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import Top from "./Top";

const APP_STORE_URL = "https://apps.apple.com/app/flateroo/id6683311358";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.flateroo.flateroo";

const Marketing = () => {
  const { uuid } = useParams();
  const posthog = usePostHog();

  useEffect(() => {
    try {
      posthog?.capture("marketing_visit", {
        uuid,
        userAgent: navigator.userAgent,
        referrer: document.referrer || null,
        path: window.location.pathname,
      });
    } catch (_) {}

    const ua = navigator.userAgent || navigator.vendor;
    const isIphone = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);

    if (isIphone) {
      window.location.href = APP_STORE_URL;
    } else if (isAndroid) {
      window.location.href = PLAY_STORE_URL;
    }
  }, [posthog, uuid]);

  return <Top />;
};

export default Marketing;
